import { apiCall } from "../../../_utils";
import { apiUrls } from "../../../_constants";

export const coreService = {
  getCoreIssuers,
  getCoreDomains,
  getCoreCurrencies
};

function getCoreIssuers() {
  return apiCall("GET", apiUrls.issuers.core);
}

function getCoreDomains(requestParams) {
  return apiCall("GET", apiUrls.domains.core, null, requestParams);
}

function getCoreCurrencies() {
  return apiCall("GET", apiUrls.currencies.core);
}
